module.exports = __webpack_public_path__ + "img/info.d9041227.svg";